<template>
	<v-app id="inspire">
		<v-content>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-2">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title>OSBOD Student Portal</v-toolbar-title>
								<div class="flex-grow-1"></div>
							</v-toolbar>
							<v-card-text class="pt-6">
								<p class="body-1 mb-4">
									Log in met uw school Microsoft-account
									(<strong>@osbod.org</strong>).
								</p>
								<v-btn
									block
									depressed
									color="secondary"
									large
									:loading="loading"
									:disabled="loading"
									@click="onMicrosoftLogin"
								>
									<v-icon left>mdi-microsoft</v-icon>
									Inloggen met Microsoft
								</v-btn>
							</v-card-text>
						</v-card>
						<br />
						<v-alert
							:value="!!errorMessage"
							border="right"
							colored-border
							type="error"
							elevation="2"
							transition="scale-transition"
						>{{ errorMessage }}</v-alert>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
export default {
	name: "login",
	computed: {
		loggedin() {
			return this.$store.getters.getLoggedin;
		},
		loading() {
			return this.$store.getters.getLoginLoading;
		},
		errorMessage() {
			return this.$store.getters.getLoginError;
		}
	},
	watch: {
		loggedin: function(value) {
			if (value) {
				this.$router.replace({ path: "/main" });
			}
		}
	},
	async created() {
		if (this.loggedin) {
			this.$router.replace({ path: "/main" });
			return;
		}

		var completed = await this.$store.dispatch("completeEntraRedirect");
		if (completed) {
			this.$router.replace({ path: "/main" });
			return;
		}

		if (this.errorMessage) {
			return;
		}

		await this.$store.dispatch("restoreSession");
		if (this.loggedin) {
			this.$router.replace({ path: "/main" });
		}
	},
	methods: {
		onMicrosoftLogin() {
			this.$store.dispatch("loginWithEntra");
		}
	}
};
</script>
